import {Controller} from '@hotwired/stimulus'
import Inputmask from "inputmask"

export default class extends Controller {
  static targets = [
    'ccType',
    'ccNumber',
    'ccExp',
    'ccCcv',
    'ccCcvLabel',
    'submit',
  ]
  static values = {
    url: String,
    client: String,
    registrationUrl: String
  }

  connect() {
    // Set input masks
    Inputmask({mask: "99/99"}).mask(this.ccExpTarget);
    Inputmask({mask: "999"}).mask(this.ccCcvTarget);
    this.setMasks()
    this.submitTarget.setAttribute('data-card-initial-text', this.submitTarget.innerHTML)
  }

  pay(event) {
    event.preventDefault()

    this.submitTarget.disabled = true
    this.submitTarget.innerHTML = "<i class='fa fa-spinner fa-spin'></i> Chargement..."
    this.cleanFormErrors()

    // Set mangopay sdk data
    mangoPay.cardRegistration.baseURL = this.urlValue
    mangoPay.cardRegistration.clientId = this.clientValue

    fetch(this.registrationUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.getCSRFToken()
      },
      body: JSON.stringify({card_type: this.ccTypeTarget.value})
    })
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          throw new Error("Network response was not ok.")
        }
      })
      .then(data => {
        if (data.status === 'success') {
          mangoPay.cardRegistration.init({
            cardRegistrationURL: data.card_registration['CardRegistrationURL'],
            preregistrationData: data.card_registration['PreregistrationData'],
            accessKey: data.card_registration['AccessKey'],
            Id: data.card_registration['Id']
          })

          var cardData = {
            cardNumber: this.ccNumberTarget.value.replace(/ /g, ''),
            cardExpirationDate: this.ccExpTarget.value.replace('/', ''),
            cardCvx: this.ccTypeTarget.value === 'CB_VISA_MASTERCARD' ? this.ccCcvTarget.value : '000',
            cardType: this.ccTypeTarget.value
          }

          mangoPay.cardRegistration.registerCard(
            cardData,
            function (res) {
              $('#mgp_card_mangopay_id').val(res['CardId'])
              $('#mgp_card_card_type').val(res['CardType'])
              $('#browser_info_java_enabled').val(navigator.javaEnabled())
              $('#browser_info_javascript_enabled').val(true)
              $('#browser_info_color_depth').val(screen.colorDepth)
              $('#browser_info_screen_height').val(screen.height)
              $('#browser_info_screen_width').val(screen.width)
              $('#browser_info_time_zone_offset').val(new Date().getTimezoneOffset())
              $('#browser_info_language').val(navigator.language)
              $('#real_card_form').submit();
            },
            this.manageCardErrors
          )
        } else {
          $('[data-card-form-target="submit"]').html($('[data-card-form-target="submit"]').data('cardInitialText'));
          $('[data-card-form-target="submit"]').removeAttr('disabled');
        }
      })
      .catch(error => {
        console.log("Error : " + error)
        $('[data-card-form-target="submit"]').html($('[data-card-form-target="submit"]').data('cardInitialText'));
        $('[data-card-form-target="submit"]').removeAttr('disabled');
      })
  }

  setMasks() {
    if (this.ccTypeTarget.value === 'CB_VISA_MASTERCARD') {
      Inputmask({mask: "9999 9999 9999 9999"}).mask(this.ccNumberTarget);
      this.ccCcvLabelTarget.classList.remove('d-none');
      this.ccCcvLabelTarget.classList.add('d-block');
    } else {
      Inputmask.remove(this.ccNumberTarget);
      this.ccCcvLabelTarget.classList.add('d-none');
      this.ccCcvLabelTarget.classList.remove('d-block');
    }
  }

  getCSRFToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute("content")
  }

  manageCardErrors(err) {
    var msg = err.ResultMessage

    if (msg.match(/^CARD_NUMBER.*/)) {
      $('[data-card-form-target="ccNumber"]').parent('label').addClass('error')
    }
    if (msg.match(/^.*EXPIRY_DATE.*/)) {
      $('[data-card-form-target="ccExp"]').parent('label').addClass('error')
    }
    if (msg.match(/^CVV.*/)) {
      $('[data-card-form-target="ccCcv"]').parent('label').addClass('error')
    }

    $('[data-card-form-target="submit"]').html($('[data-card-form-target="submit"]').data('cardInitialText'));
    $('[data-card-form-target="submit"]').removeAttr('disabled');
  }

  cleanFormErrors() {
    $('[data-card-form-target="ccNumber"]').parent('label').removeClass('error')
    $('[data-card-form-target="ccExp"]').parent('label').removeClass('error')
    $('[data-card-form-target="ccCcv"]').parent('label').removeClass('error')
  }
}